export default {"src":"/_next/static/media/overcoming-obstacles.colour.9e0e64e3.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};